export default __webpack_public_path__ + "static/media/time.7cb1e376.svg";